import { NgModule} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedTranslateModule } from '../app/shared-translate.module';
import { SurveyAutocompleteComponent } from './components/survey-autocomplete/survey-autocomplete.component';
import {MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatButtonModule, MatProgressSpinnerModule} from '@angular/material';
import {CommService} from '../services/comm-service';
@NgModule({
  imports:      [     
    ReactiveFormsModule,
    CommonModule,
    SharedTranslateModule,   
    MatInputModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatButtonModule,
    MatProgressSpinnerModule    
    ],
  declarations: [ SurveyAutocompleteComponent ],
  exports: [SurveyAutocompleteComponent],
  entryComponents: [
    SurveyAutocompleteComponent
    ], 
  providers: [CommService],
  bootstrap:    [  ]
})
export class SurveyAutocompleteModule { }